import ApiRoutes from "../../../../constants/api-routes";
import { hneAdminApi } from "../../../../service";

export const createNewCategory = async (body) =>
  hneAdminApi.post(`${ApiRoutes.CREATE_CATEGORY}`, body);

export const getAllCategory = async () =>
  hneAdminApi.get(`${ApiRoutes.GET_ALL_CATEGORY}`);

export const updateCategory = async (body, category_id) =>
  hneAdminApi.put(`${ApiRoutes.UPDATE_CATEGORY}/${category_id}`, body);

export const getAllMenus = async () =>
  hneAdminApi.get(`${ApiRoutes.GET_ALL_MENUS}`);

export const getCategoryById = async (category_id) =>
  hneAdminApi.get(`${ApiRoutes.GET_CATEGORY}/${category_id}`);
